import "./tournament-promotion-banner-image-edit-image.scss";
import React from "react";
import { GSForm, GSSidePanelPage } from "golfstatus_react_components";
import { faChevronLeft, faUndoAlt } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  selectCurrentTournament,
  setCurrentTournament,
  setCurrentTournamentPromotion,
} from "../../../reducers/tournamentSlice";
import {
  useFormDataValidation,
  useImageCropper,
} from "../../../hooks/formHooks";
import { useEffect } from "react";
import { tournamentPromotionImageEditForm } from "../../../forms/TournamentForms";
import {
  selectCroppedImage,
  setCroppedImage,
} from "../../../reducers/utilitySlice";

const TournamentPromotionBannerImageEditImage = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const croppedImage = useSelector(selectCroppedImage);

  const currentTournament = useSelector(selectCurrentTournament);
  const tournamentPromotion = currentTournament?.tournamentPromotion;
  const property = "heroBannerPhoto";

  const [context, isValid] = useFormDataValidation({
    initialValid: true,
    data: currentTournament?.tournamentPromotion ?? {},
    setData: setCurrentTournamentPromotion,
  });

  const [croppedImg, showCroppedImage, , applyCrop, undoCrop, croppedImgBlob] = useImageCropper(
    context,
    property
  );

  useEffect(() => {
    const editor = document.getElementById("image-editor");
    editor.focus();
  }, []);

  const getDrawerActions = () => {
    let actions = [
      {
        name: "Save",
        isDisabled: !isValid,
        action: saveLogo,
        type: "black",
      },
      { name: "cancel", action: leftNavigation, type: "grey" },
    ];
    return actions;
  };

  const saveLogo = () => {
    let updateTournament = { ...currentTournament };
    let updateTournamentPromotion = {
      ...currentTournament.tournamentPromotion,
    };
    updateTournamentPromotion.heroBannerPhoto = croppedImg;
    updateTournament.tournamentPromotion = updateTournamentPromotion;
    dispatch(setCurrentTournament(updateTournament));
    dispatch(setCroppedImage({ ...croppedImage, heroBannerPhoto: croppedImg }));
    leftNavigation();
  };

  const leftNavigation = () => {
    navigate(-1);
  };

  const getNavigation = () => {
    return {
      title: `Edit Banner Image`,
      leftIcon: faChevronLeft,
      leftButtonClick: leftNavigation,
    };
  };

  context.getActions = () => {
    if (!showCroppedImage) {
      return [
        { buttonTitle: "Preview", actionClick: applyCrop, type: "transparent" },
      ];
    } else {
      return [
        {
          buttonTitle: "revert",
          actionIcon: faUndoAlt,
          actionClick: undoCrop,
          type: "transparent red",
        },
      ];
    }
  };

  context.getLogo = () => {
    return tournamentPromotion?.[property];
  };

  const getContent = () => {
    return (
      <GSForm
        formTitle="Edit Image"
        formActions={context.getActions()}
        formSections={tournamentPromotionImageEditForm(
          context,
          showCroppedImage,
          croppedImg
        )}
      ></GSForm>
    );
  };

  const getDrawer = () => {
    return {
      actions: getDrawerActions(),
    };
  };

  const keyPressed = () => {
    saveLogo();
  };

  return (
    <tournament-promotion-banner-image-edit-image
      id="image-editor"
      onKeyPress={keyPressed}
      tabIndex={1}
    >
      <GSSidePanelPage
        header={getNavigation()}
        content={getContent()}
        drawer={getDrawer()}
        loading={croppedImgBlob === undefined}
        loadingText={"Loading Image..."}
      ></GSSidePanelPage>
    </tournament-promotion-banner-image-edit-image>
  );
};

export default TournamentPromotionBannerImageEditImage;
